import React from "react";

export default class DocumentationPageLoading extends React.Component {
    public render(): React.ReactNode {
        return (
            <div className="documentation-content no-examples documentation-loading">
                <div className="header-wrapper">
                    <h1><span className="loading-span" /></h1>
                    <ul>
                        <li><span className="loading-span" /></li>
                        <li><span className="loading-span" /></li>
                        <li><span className="loading-span" /></li>
                    </ul>
                </div>
                <div className="section">
                    <h2><span className="loading-span" /></h2>
                    <h4><span className="loading-span" /></h4>
                </div>
            </div>
        );
    }
}
